import loadingPng from '@/assets/images/icon_ok.png'
import React, { FC } from 'react'
import './index.less'

interface TipProps {
	bgColor: string
	tipText: string
	top: string
}

const TipBox: FC<TipProps> = ({ bgColor, tipText, top }) => {
	return (
		<div className="tipBox" style={{ backgroundColor: bgColor, top: top }}>
			<img src={loadingPng} alt="" />
			<span>{tipText}</span>
		</div>
	)
}

export default TipBox
